import script from "./UChoosePlan.vue?vue&type=script&setup=true&lang=ts"
export * from "./UChoosePlan.vue?vue&type=script&setup=true&lang=ts"

import "./UChoosePlan.vue?vue&type=style&index=0&id=5aa4ea16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aa4ea16"]])

export default __exports__